<template>
  <v-dialog v-model="showModal" width="600">
    <modal-card
      :title="dialogInfo ? dialogInfo.title : 'Info'"
      @close="showModal = false"
      full
      padding
    >
      <component class="info-dialog-text" :is="infoComponent" />
    </modal-card>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/lib/events';

export default {
  name: 'RoomInfoDialog',
  data() {
    return {
      showModal: false,
      dialogType: '',
      dialogTypes: {
        ended: {
          title: 'Meeting has Ended',
          component: 'InfoMeetingEnded',
        },
        alreadyJoined: {
          title: 'Already Joined',
          component: 'InfoAlreadyJoined',
        },
        deviceNotFound: {
          title: 'Camera or Microphone Not Found',
          component: 'InfoDeviceNotFound',
        },
        alreadyInUse: {
          title: 'Your camera or microphone is already in use',
          component: 'InfoDeviceAlreadyInUse',
        },
        permissionDenied: {
          title: 'Camera and Microphone Blocked',
          component: 'InfoPermissionDenied',
        },
        generalDeviceError: {
          title: 'Something is wrong with your Camera or Microphone',
          component: 'InfoGeneralDeviceError',
        },
        getUserMedia: {
          title: 'Camera and Microphone Not Supported',
          component: 'InfoGetUserMedia',
        },
      },
    };
  },
  props: {
    value: {},
  },
  computed: {
    dialogInfo() {
      return this.dialogTypes[this.dialogType];
    },
    infoComponent() {
      const component = this.dialogInfo?.component || '';
      if (!component) return;

      return () => import(`./info-messages/${component}`);
    },
  },
  methods: {
    showDialog(type) {
      this.dialogType = type;
      this.showModal = true;
    },

    parseUserMediaError(err) {
      const { name = '' } = err || {};

      if (['NotFoundError', 'DevicesNotFoundError'].includes(name)) {
        return 'deviceNotFound';
      }

      if (['NotReadableError', 'TrackStartError'].includes(name)) {
        return 'alreadyInUse';
      }

      if (['NotAllowedError', 'PermissionDeniedError'].includes(name)) {
        return 'permissionDenied';
      }

      return 'generalDeviceError';
    },
  },
  created() {
    eventBus.on('showRoomInfoDialog', ({ type, mediaError }) => {
      if (mediaError) {
        type = this.parseUserMediaError(mediaError);
      }

      this.showDialog(type);
    });
  },
};
</script>

<style lang="less">
.info-dialog-text {
  p {
    margin-bottom: 8px;
  }
}
</style>
